// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/feeding-ducks.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const feedingDucks: Score = {
  slug: "feeding-ducks",
  n: 6,
  title: "Feeding Ducks",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "F",
  fifths: -1,
  time: [4, 4],
  tempo: 84,
  staves: 1,
  clefs: ["treble"],
  bars: 8,
  barQuarters: 4.0,
  lowest: 60,
  highest: 72,
  hasLyrics: false,
  jasonNote: "Here's a tune for you on F Major which introduces you to dotted 8th notes. Try counting or tapping your foot while playing. Remember, F Major has 1 flat (Bb).",
  teaches: ["the dotted-note figure", "counting while playing", "F major and its one flat"],
  art: "/sight-reading/art/feeding-ducks.jpg",
  artRights: "stock",
  background: "/sight-reading/bg/feeding-ducks.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.5, midi: 72, pitch: "C5", d: "quarter", dot: true },
    { bar: 1, hand: "rh", start: 1.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.5, midi: 65, pitch: "F4", d: "quarter", dot: true },
    { bar: 1, hand: "rh", start: 3.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 2, hand: "rh", start: 4.0, dur: 2.0, midi: 67, pitch: "G4", d: "half" },
    { bar: 2, hand: "rh", start: 6.0, dur: 2.0, midi: 72, pitch: "C5", d: "half" },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.5, midi: 60, pitch: "C4", d: "quarter", dot: true },
    { bar: 3, hand: "rh", start: 9.5, dur: 0.5, midi: 60, pitch: "C4", d: "eighth" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.5, midi: 62, pitch: "D4", d: "quarter", dot: true },
    { bar: 3, hand: "rh", start: 11.5, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 4, hand: "rh", start: 12.0, dur: 4.0, midi: 65, pitch: "F4", d: "whole" },
    { bar: 5, hand: "rh", start: 16.0, dur: 1.5, midi: 72, pitch: "C5", d: "quarter", dot: true },
    { bar: 5, hand: "rh", start: 17.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 5, hand: "rh", start: 18.0, dur: 1.5, midi: 65, pitch: "F4", d: "quarter", dot: true },
    { bar: 5, hand: "rh", start: 19.5, dur: 0.5, midi: 69, pitch: "A4", d: "eighth" },
    { bar: 6, hand: "rh", start: 20.0, dur: 2.0, midi: 67, pitch: "G4", d: "half" },
    { bar: 6, hand: "rh", start: 22.0, dur: 2.0, midi: 72, pitch: "C5", d: "half" },
    { bar: 7, hand: "rh", start: 24.0, dur: 1.5, midi: 60, pitch: "C4", d: "quarter", dot: true },
    { bar: 7, hand: "rh", start: 25.5, dur: 0.5, midi: 60, pitch: "C4", d: "eighth" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.5, midi: 62, pitch: "D4", d: "quarter", dot: true },
    { bar: 7, hand: "rh", start: 27.5, dur: 0.5, midi: 64, pitch: "E4", d: "eighth" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 65, pitch: "F4", d: "whole" },
  ],
};
